import { v4 as uuid } from 'uuid';
import { USER_DIALOG_ACTION_TYPES } from '../../constants/userDialog.constants';

export const showCredentialDialog = ({ requestId = uuid(), ...options } = {}) => ({
  type: USER_DIALOG_ACTION_TYPES.SHOW_CREDENTIAL_DIALOG,
  payload: { ...options, requestId },
});

export const hideCredentialDialog = (requestId) => ({
  type: USER_DIALOG_ACTION_TYPES.HIDE_CREDENTIAL_DIALOG,
  payload: { requestId },
});

export const credentialDialogSaved = (credential, requestId) => ({
  type: USER_DIALOG_ACTION_TYPES.CREDENTIAL_DIALOG_SAVED,
  payload: { credential, requestId },
});
